<template>
  <div class="upload">
    <input type="file" style="display: none" id="file" :multiple="multiple" />
    <el-button type="primary" :size="size" @click="uploadFileHandler">{{
      isAuthUpload ? '点击上传' : '选择文件'
    }}</el-button>
    <el-button v-if="!isAuthUpload" type="primary" :size="size" @click="submitUploadHandler"
      >开始上传</el-button
    >
    <template v-if="isShowTip">
      <div v-for="(item, index) of currentFileList" :key="index" class="file-tip">
        <label>
          <i class="el-icon-document"></i>
          {{ item.name }}
        </label>
        <label>
          <i class="el-icon-circle-check info-icon" style="color: #67c23a"></i>
          <i class="el-icon-close del-icon" @click="deleteFileHandler(item)"></i>
        </label>
      </div>
    </template>
  </div>
</template>
<script>
  import path from 'path';
  export default {
    name: 'IElUploadFile',
    props: {
      // 按钮大小
      size: {
        type: String,
        default: 'small',
      },
      // 文件大小单位M
      fileSize: {
        type: Number,
        default: 0,
      },
      // 支持的文件格式['png','gif','jpeg','jpg']
      fileType: {
        type: Array,
        default: () => [],
      },
      // 上传的回调方法
      uploadHandler: {
        type: Function,
      },
      // 是否自动上传
      isAuthUpload: {
        type: Boolean,
        default: false,
      },
      // 上传给后端接收的字段名
      fileName: {
        type: String,
        required: true,
      },
      // 是否上传多张
      multiple: {
        type: Boolean,
        default: true,
      },
      // 是否显示提示
      isShowTip: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        currentFileList: [],
        fileNode: null,
      };
    },
    methods: {
      // 上传文件
      uploadFileHandler() {
        // 触发原始上传文件的点击事件
        this.fileNode.click();
        this._uploadFile();
      },
      _uploadFile() {
        const that = this;
        this.fileNode.addEventListener('change', function (ev) {
          const postFiles = Array.prototype.slice.call(ev.target.files);
          that.currentFileList = [...postFiles];
          if (that.isAuthUpload) {
            that.submitUploadHandler();
          }
        });
      },
      submitUploadHandler() {
        if (!this.currentFileList.length) {
          this.$message.warning('请选择上传的文件');
          return false;
        }
        let formData = new FormData();
        let flag = true;
        for (const item of this.currentFileList) {
          flag = this.beforeUpload(item);
          formData.append(this.fileName, item, item.name);
        }
        if (!flag) {
          return false;
        }
        this.uploadHandler && this.uploadHandler(formData);
      },
      // 上传前的钩子函数(根据你需求放到哪里去)
      beforeUpload(file) {
        const { name, size } = file;
        // 文件格式化校验
        if (this.fileType.length) {
          const supportFileType = this.fileType?.join('|');
          if (!new RegExp('(' + supportFileType + ')$', 'i').test(path.extname(name))) {
            this.$message.error(`文件格式不正确,只能上传【${this.fileType.join(',')}】格式文件`);
            return false;
          }
        }
        if (this.fileSize > 0) {
          // 文件大小
          if (size > this.fileSize * 1024 * 1024) {
            this.$message.warning(`文件过大,请上传小于${this.fileSize}MB的文件`);
            return false;
          }
        }
        return true;
      },
      deleteFileHandler(file) {
        const index = this.currentFileList.findIndex((item) => item.name == file.name);
        this.currentFileList.splice(index, 1);
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.fileNode = document.getElementById('file');
      });
    },
  };
</script>

<style scoped lang="scss">
  .upload {
    .file-tip {
      width: 300px;
      height: 30px;
      line-height: 30px;
      display: flex;
      justify-content: space-between;
      .btn-group {
        display: flex;
        justify-content: center;
        flex-direction: column;
      }
      &:hover {
        cursor: pointer;
        background-color: #f5f7fa;
        .del-icon {
          display: inline-block;
        }
        .info-icon {
          display: none;
        }
      }
      .del-icon {
        cursor: pointer;
        display: none;
      }
    }
  }
</style>
